import { Box, Typography } from "@mui/material";

// utils
import { validateInputNum } from "../../utils/input-validations";

// svg
import { ReactComponent as IconArrowDown } from "../../assets/svg/arrow-triangle-down.svg";
import { ReactComponent as IconArrowUp } from "../../assets/svg/arrow-triangle-up.svg";

// style
import "./text-field-num.css";
import { COLORS_GLOBAL } from "../../constants/colors.constants";


export const TextFieldNum = ({
  label,
  unit = "",
  requier = false,
  placeholder = "",
  value,
  setValue,
  error = null,
  small = false,
  stepSize = 1,
  min = 0,
  max = null,
  decimalPlaces = 0,
  disabled = false,
}) => {
  // set value
  const setValueHandler = (val) => {
    const error = val === '' ? null :validateInputNum(val, min, max, unit);
    setValue(val, error);
  };

  // handle input change
  const handleChange = (e) => {
    const val = e.target.value.trim().replace(",", ".");
    setValueHandler(val);
  };

  // increment value
  const increment = () => {
    let currentValue = Number(value) || 0;
    if (max && currentValue > max) return;

    currentValue = currentValue + Number(stepSize);
    const newValue = currentValue.toFixed(decimalPlaces);
    setValueHandler(newValue);
  };

  // decrement value
  const decrement = () => {
    let currentValue = Number(value) || 0;
    if (currentValue < min) return;

    currentValue = currentValue - Number(stepSize);
    const newValue = currentValue.toFixed(decimalPlaces);
    setValueHandler(newValue);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <Typography  sx={{ fontSize: "12px", color: "#343745", ml: "8px", fontWeight: 500  }} >
        {label} {unit && <span style={{ color: "#a2a3a3" }}>[{unit}]</span>}
      </Typography>
      <Box
        sx={{
          borderRadius: small ? "6px" : "8px",
          height: small ? "32px" : "38px",
          borderColor: error ? "#ba1a1a" : "#dbdbeb",
        }}
        className="tf-num-container"
      >
        <input
          type="text"
          className="tf-num-input"
          value={value === undefined || value === null ? '' : value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
        />
        <div className="tf-num-controls">
          <button
            type="button"
            className="tf-num-btn up-btn"
            onClick={increment}
            aria-label="Increment"
            disabled={disabled}
          >
            <IconArrowUp fill={disabled ? COLORS_GLOBAL.BTN_DISABLED : COLORS_GLOBAL.MAIN_DARK} />
          </button>
          <button
            type="button"
            className="tf-num-btn down-btn"
            onClick={decrement}
            aria-label="Decrement"
            disabled={disabled}
          >
            <IconArrowDown fill={disabled ? COLORS_GLOBAL.BTN_DISABLED : COLORS_GLOBAL.MAIN_DARK} />
          </button>
        </div>
      </Box>
     {error && ( 
      <Typography ml="8px" fontSize={"12px"} color="#ba1a1a">
        {error}
      </Typography>
      )} 
    </Box>
  );
};
